import { useMemo } from 'react';

import { usePetsafeInternationalContext } from '@util/static-translations';

const useAllCollections = () => {
  const { locale } = usePetsafeInternationalContext();

  let allCollectionsCache = {};
  try {
    // This file is generated during runtime, so it is not committed to Git
    // This is expected for the IDE to show an error message before the first build
    // eslint-disable-next-line import/no-unresolved , global-require
    allCollectionsCache = require('../../content/allCollections.json');
  } catch {
    allCollectionsCache = {};
  }

  return useMemo(
    () => allCollectionsCache?.[locale],
    [allCollectionsCache, locale]
  );
};

export default useAllCollections;
